<template>
  <Chart
    :size="{ width: width, height: height }"
    :data="plotData"
    :margin="margin"
    :direction="direction"
    :axis="axis"
    class="text-sm text-gray-over-dark"
  >
    <template #layers>
      <!-- <Grid strokeDasharray="2,2" /> -->
      <Area
        :data-keys="['name', 'pl']"
        type="monotone"
        :area-style="{ fill: fillGradient }"
      />
      <Line
        :data-keys="['name', 'pl']"
        type="monotone"
        :line-style="{
          stroke: chartColor,
        }"
        :dot-style="{
          stroke: '#ffffff',
          r: 12,
          strokeWidth: 12,
        }"
      />
      <Line
        :data-keys="['name', 'pl']"
        type="monotone"
        :line-style="{
          stroke: chartColor,
          strokeWidth: 0,
        }"
        :dot-style="{
          stroke: chartColor,
          r: 8,
          strokeWidth: 6,
        }"
      />
      <Labels :data-keys="['name', 'pl']" />
      <Marker
        v-if="marker"
        :value="top10Pct"
        style="font-size: 12px"
        label="Top 10% of carriers"
        color="#A9ADBD"
        :stroke-width="strokeWidth"
        stroke-dasharray="12 12"
      />
      <Marker
        v-if="marker"
        :value="bottom10Pct"
        style="font-size: 12px"
        label="Bottom 10% of carriers"
        color="#A9ADBD"
        :stroke-width="strokeWidth"
        stroke-dasharray="12 12"
      />
      <defs>
        <linearGradient
          id="grad"
          gradientTransform="rotate(90)"
        >
          <stop
            offset="0%"
            stop-color="#f8c617"
            stop-opacity="1"
          />
          <stop
            offset="100%"
            stop-color="white"
            stop-opacity="0.4"
          />
        </linearGradient>
        <linearGradient
          id="grad2"
          gradientTransform="rotate(90)"
        >
          <stop
            offset="0%"
            stop-color="#ff9330"
            stop-opacity="1"
          />
          <stop
            offset="100%"
            stop-color="white"
            stop-opacity="0.4"
          />
        </linearGradient>
      </defs>
    </template>

    <template #widgets>
      <!-- <Tooltip
        borderColor="#48CAE4"
        :config="{
          pl: { color: '#9f7aea' },
        }"
      /> -->
    </template>
  </Chart>
</template>

<script lang="ts">
import { Chart, Line, Marker, Area } from 'vue3-charts';
import { defineComponent, ref, computed } from 'vue';
import Labels from './Labels.vue';

export default defineComponent({
  name: 'LineChart',
  // components: { Chart, Grid, Line, Marker, Area, Labels },
  components: { Chart, Line, Marker, Area, Labels },
  props: {
    width: {
      type: Number,
      required: true,
    },
    height: {
      type: Number,
      required: true,
    },
    plotData: {
      type: Array,
      required: true,
    },
    top10Pct: {
      type: Number,
      required: true,
    },
    bottom10Pct: {
      type: Number,
      required: true,
    },
    color: {
      type: String,
      required: false,
    },
  },

  setup(props) {
    // var plByMonth = [
    //   { name: 'Jan', pl: 1000, avg: 500, inc: 300 },
    //   { name: 'Feb', pl: 2000, avg: 900, inc: 400 },
    //   { name: 'Apr', pl: 400, avg: 400, inc: 500 },
    //   { name: 'Mar', pl: 3100, avg: 1300, inc: 700 },
    //   { name: 'May', pl: 200, avg: 100, inc: 200 },
    //   { name: 'Jun', pl: 600, avg: 400, inc: 300 },
    //   { name: 'Jul', pl: 500, avg: 90, inc: 100 }
    // ]
    // const data = ref(plByMonth);
    // const width = ref(width)
    // const height = ref(height)
    // const plotData = ref(plotData)
    // const top10Pct = ref(top10Pct)
    // const bottom10Pct = ref(bottom10Pct)
    const direction = ref('horizontal');
    // const top10PctVal = ref(props.top10Pct);
    // const bottom10PctVal = ref(props.bottom10Pct);
    const margin = ref({
      left: 0,
      top: 0,
      right: 0,
      bottom: 0,
    });
    const marker = true;
    const strokeWidth = 1;

    const fillGradient = computed(() => {
      if (props.color == 'orange') {
        return `url(#grad2)`;
      } else {
        return `url(#grad)`;
      }
    });

    const chartColor = computed(() => {
      if (props.color == 'orange') {
        return `#ff9330`;
      } else {
        return `#f8c617`;
      }
    });

    const axis = ref({
      primary: {
        type: 'band',
        ticks: 6,
      },
      secondary: {
        domain: ['dataMin - 0.1', 'dataMax * 1.5 + 0.1'],
        // domain: [ bottom10Pct * 0.8, top10Pct * 1.1 ],
        type: 'linear',
        ticks: 6,
      },
    });

    // axis.value.primary.domain = ['0', dataMaximumX.value];
    // axis.value.secondary.domain = ['0.9*'+bottom10PctVal.value.toString()+' - 0.5', '1.1*'+top10PctVal.value.toString()+' + 0.5'];

    return {
      direction,
      margin,
      axis,
      marker,
      strokeWidth,
      fillGradient,
      chartColor,
    };
  },
});
</script>

<style scoped>
g.layer-axis-x,
g.layer-axis-y {
  color: #c7cbdb;
}
</style>
